import axios from 'axios';
import { toast } from 'sonner';
import { getTranslation } from '@/lib/i18n';

const rawBase =
  process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || '';
const API_URL = rawBase.replace(/\/$/, '');

const api = axios.create({
  baseURL: API_URL ? `${API_URL}/api` : '/api',
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('salon_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('salon_token');
      localStorage.removeItem('salon_user');
      toast.error(getTranslation('auth_session_expired'));
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
